// https://vuex.vuejs.org/kr/guide/actions.html#%EC%95%A1%EC%85%98
import { ActionTree } from 'vuex';
export default <ActionTree<RootState, RootState>>{
};
